import React from 'react';
import { SPECIALTY_COVID_19_VACCINATIONS } from '../../../../../../../bookings/constants';
import { PracticeTag } from '../../../../../../../common/schema/hannibal/types.generated';
import { Tag } from './Tag';
import {
  BulkBilledIcon,
  HomeIcon,
  OfferIcon,
  PersonIcon,
  TelehealthEnabledIcon,
  TelehealthIcon,
  UberIcon,
  WalkInIcon,
} from './Tag.styles';

const SPECIAL_ORDERING = [
  PracticeTag.BulkBilling,
  PracticeTag.Telehealth,
  PracticeTag.TeleEnabled,
  PracticeTag.ExistingPatientsOnly,
  PracticeTag.SpecialOffer,
  PracticeTag.WalkIns,
  PracticeTag.HomeVisit,
  PracticeTag.UberPreferred,
];

export const tagFactory = (tags: PracticeTag[], specialty?: string) => {
  const elements = SPECIAL_ORDERING.map(tag => {
    if (!tags.includes(tag)) {
      return null;
    }

    switch (tag) {
      case PracticeTag.BulkBilling:
        return <Tag icon={<BulkBilledIcon />}>Bulk billing</Tag>;
      case PracticeTag.ExistingPatientsOnly:
        return <Tag icon={<PersonIcon />}>Existing patients only</Tag>;
      case PracticeTag.SpecialOffer:
        return <Tag icon={<OfferIcon />}>Special offer</Tag>;
      case PracticeTag.WalkIns:
        return <Tag icon={<WalkInIcon />}>Walk-ins</Tag>;
      case PracticeTag.HomeVisit:
        return <Tag icon={<HomeIcon />}>Home visits</Tag>;
      case PracticeTag.UberPreferred:
        return <Tag icon={<UberIcon />}>Uber</Tag>;
      default:
        return null;
    }
  });

  if (specialty !== SPECIALTY_COVID_19_VACCINATIONS) {
    return [
      ...elements,
      tags.includes(PracticeTag.Telehealth) ? (
        <Tag icon={<TelehealthIcon />}>Telehealth only</Tag>
      ) : null,
      tags.includes(PracticeTag.TeleEnabled) && !tags.includes(PracticeTag.Telehealth) ? (
        <Tag icon={<TelehealthEnabledIcon />}>Telehealth</Tag>
      ) : null,
    ];
  }

  return elements;
};
